import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

const container = document.getElementById('root')
if (container === null) {
  throw new Error('找不到 #root 容器，检查 index.html')
}

createRoot(container).render(
  <StrictMode>
    {/* 服务端已配置 SPA 回退，深链接（如 /settings）刷新不会 404 */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
